import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CrAlert } from 'app/services/crsync.service';
import { MomentPipe } from '../../../../pipes/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { SlicePipe } from '@angular/common';

@Component({
    selector: 'app-cr-notes-list',
    templateUrl: './cr-notes-list.component.html',
    styles: [`
    .alertCardClickTarget {
      color: #1D83E9;
      cursor: pointer;
      }
      `],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [SlicePipe, TranslateModule, MomentPipe]
})
export class CrNotesListComponent implements OnInit {

  constructor() { }

  @Input() alert: CrAlert;

  noteShowCount = 1;

  ngOnInit(): void {
  }

}
